export default {
  methods: {
    async getBanner(cateCode) {
      const { result, list } = await this.$api.getBanner({ cateCode: cateCode })
      return result === 'success' ? list : []
    },
  },
}
